export enum Roles {
  Spv = 'agency.spvcockpit.spv',
  Bm = 'agency.spvcockpit.bm',
  Abpm = 'agency.spvcockpit.abpm',
  Am = 'agency.spvcockpit.am',
  HoViewer = 'agency.spvcockpit.ho-viewer',
  HoEditor = 'agency.spvcockpit.ho-editor',
  HoApprover = 'agency.spvcockpit.ho-approver',
  None = 'none',
}
